'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = ['', 'M235.3 245.6L27 141.5c4.8-9.6 10.2-18.8 16.1-27.7 45.9-68.6 124.1-113.8 212.9-113.8 141.4 0 256 114.6 256 256 0 29.8-5.1 58.4-14.4 85-3.5 10.1-7.7 19.9-12.5 29.5l-221.1-110.6-110 220 358.1 0 0 32-512 0 0-32 118.1 0 117.2-234.4zM480 256c0-123.7-100.3-224-224-224-76.2 0-143.5 38-184 96.2L468.7 326.6C476 304.4 480 280.7 480 256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;